function n(l){return l!==null}export{n as a};
